import { Navigate } from "react-router-dom";
import { AppShell } from "../components/AppShell";
import { DriveCard } from "../components/dashboard/DriveCard";
import { ResetDocuments } from "../components/dashboard/ResetDocuments";
import { isAdmin, useAuth } from "../context/AuthContext";

// REQ-392/393: Admin-only screen with the Drive controls and the reset card.
export default function DrivePage() {
  const { user } = useAuth();
  if (!isAdmin(user)) return <Navigate to="/" replace />;
  return (
    <AppShell>
      <section className="tr-fade-up" data-testid="drive-page">
        <div className="tr-eyebrow">Administración</div>
        <h1 className="text-2xl font-extrabold tracking-tight text-[#182235] sm:text-3xl">Google Drive</h1>
      </section>
      <DriveCard />
      <ResetDocuments onChanged={() => {}} />
    </AppShell>
  );
}
